import React, {Component} from "react";
import {Card, Container, Form, Button, Alert, Spinner} from 'react-bootstrap'
import ReCAPTCHA from "react-google-recaptcha";
import {withTranslation} from 'react-i18next';


import './sms-form.css'

class SmsForm extends Component {

    state = {
        iin: '',
        smsCode: '',
        iinValidated: false,
        smsValidated: false,
        recaptcha: false,
    }

    reCaptchaSuccess = () => {
        this.setState({
            ...this.state,
            recaptcha: true,
        });
    }

    reCaptchaErrored = () => {
        this.setState({
            ...this.state,
            recaptcha: false,
        });
    }

    reCaptchaExpired = () => {
        this.setState({
            ...this.state,
            recaptcha: false,
        });
    }

    iinOnChange = (e) => {
        const iinRegExp = new RegExp('^[0-9]*$')
        const {target: {value}} = e
        if (!iinRegExp.test(value)) {
            return
        }
        let iinValidated = false
        const newValue = value.substring(0, 12)
        if (newValue.length === 12) {
            iinValidated = true
        }

        this.setState({
            ...this.state,
            iinValidated: iinValidated,
            iin: newValue,
        })
    }

    smsOnChange = (e) => {
        const smsRegExp = new RegExp('^[0-9]*$')
        const {target: {value}} = e
        if (!smsRegExp.test(value)) {
            return
        }
        let smsValidated = false
        const newValue = value.substring(0, 4)
        if (newValue.length === 4) {
            smsValidated = true
        }

        this.setState({
            ...this.state,
            smsValidated: smsValidated,
            smsCode: newValue,
        })
    }

    sendSms = (e) => {
        e.preventDefault()
        const {sendSms} = this.props
        const {iin} = this.state
        sendSms(iin)
        return
    }

    verificationSms = (e) => {
        e.preventDefault()
        const {checkSms} = this.props
        const {smsCode} = this.state
        checkSms(smsCode)
        return
    }

    getSpinner = () => {
        const {smsData: {sendingSms, checkingSms}} = this.props
        if (sendingSms || checkingSms) {
            return <Spinner animation="border" size="sm"/>
        }
        return null
    }

    getButton = () => {
        const {recaptcha, iinValidated, smsValidated} = this.state
        const {isCheckSms, t} = this.props
        const {smsData: {sendingSms, checkingSms}} = this.props
        const btnDisabled = !((!isCheckSms && recaptcha && iinValidated) || (isCheckSms && smsValidated))
            || sendingSms || checkingSms

        return (
            <Button
                type="submit"
                variant="primary apay-sms-form-btn w-100"
                disabled={btnDisabled}
            >
                {this.getSpinner()} &nbsp; {t("paymentForm.sendBtn.label")}
            </Button>
        )
    }

    getSmsCodeInput = () => {
        const {smsData: {data: {mobilePhone}}, isCheckSms, t} = this.props
        if (isCheckSms) {
            const {smsCode} = this.state
            return (
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label className="apay-sms-form-label">{t("paymentForm.smsCode.label")}
                        телефона {mobilePhone}</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={t("paymentForm.smsCode.placeholder")}
                        size="md"
                        value={smsCode}
                        onChange={this.smsOnChange}
                    />
                </Form.Group>
            )
        }
        return null
    }

    getGoogleCaptcha = () => {
        const {isCheckSms} = this.props
        if (!isCheckSms) {
            return (
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <ReCAPTCHA
                        sitekey="6Lf3sXMdAAAAAPflJMWlt5562rLPrg_C-NCJtqKC"
                        onChange={this.reCaptchaSuccess}
                        onExpired={this.reCaptchaExpired}
                        onErrored={this.reCaptchaErrored}
                    />
                </Form.Group>
            )
        }
        return null
    }

    getFormOnSubmit = () => {
        const {isCheckSms} = this.props
        if (isCheckSms) {
            return this.verificationSms
        } else {
            return this.sendSms
        }
    }

    getErrorMessage = () => {
        const {smsData: {error, clientNotFound, smsCodeInvalid}, isCheckSms, t} = this.props
        let errorMessage = ''
        if (error !== null) {

            if (!isCheckSms) {
                errorMessage = t("errors.smsCodeSend")
            } else {
                errorMessage = t("errors.smsCodeCheck")
            }

        }
        if (clientNotFound) {
            errorMessage = t("errors.clientNotFound")
        }
        if (smsCodeInvalid) {
            errorMessage = t("errors.smsCodeWrong")
        }
        if (errorMessage === '') {
            return null
        }
        return (
            <Alert variant='danger'>
                {errorMessage}
            </Alert>
        )
    }

    render() {
        const {iin} = this.state
        const {isCheckSms, backToShopLink, t} = this.props
        return (
            <Container className="d-flex flex-row justify-content-center h-100">

                <div className="apay-sms-form mt-5">
                    <div className="apay-sms-form-title">
                        {t("paymentForm.title")}

                    </div>
                    <Card className="rounded-5 p-2">
                        <Card.Body>
                            {this.getErrorMessage()}
                            <Form onSubmit={this.getFormOnSubmit()}>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label
                                        className="apay-sms-form-label">{t("paymentForm.iin.label")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t("paymentForm.iin.placeholder")}
                                        size="md"
                                        value={iin}
                                        onChange={this.iinOnChange}
                                        readOnly={isCheckSms}
                                    />
                                </Form.Group>
                                {this.getGoogleCaptcha()}
                                {this.getSmsCodeInput()}
                                {this.getButton()}
                            </Form>
                        </Card.Body>
                    </Card>
                    {backToShopLink}
                </div>
            </Container>
        )
    }
}

export default withTranslation()(SmsForm)